import styled from 'styled-components';
import ArrowUp from './assets/arrowUp.svg';
import ArrowDown from './assets/arrowDown.svg';
import Bandeira from './assets/Bandeira Brasil.svg';

export const Brasil = styled(Bandeira)`
width: 23px;
`

export const Section = styled.div`
  width: 50%;

  @media (max-width: 820px) {
    width: 100%;
  }

  svg{
    fill: #009640 !important;
  }
`;

export const Label = styled.div`
  text-align: center;
  letter-spacing: 2px;
  color: #6C6C6C;
  text-transform: uppercase;
  opacity: 1;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid var(--light-gray);

  align-items: center;
  p{
    height: 15px;
  text-align: left;
  letter-spacing: 2px;
  color: #6C6C6C;
  opacity: 1;
  font-size: 10px;
  padding: 19px;
  @media (max-width: 820px) {
    text-align: center;
  }
  display: flex;
  align-items: center;
}
`;

export const ContentRow = styled.div`
  padding: .6rem 0 .3rem .6rem;
  border-bottom: 1px solid var(--light-gray);
  text-align: center;
  p{
    margin: 0;
    color: #161615;
    font-weight: 600;
  
  }

  @media (max-width: 820px) {
    padding:.4rem
  }
`;

export const ArrowUpIcon = styled(ArrowUp)`
  width: 9px;
  height: 13px;
`;

export const ArrowDownIcon = styled(ArrowDown)`
  width: 9px;
  height: 13px;
`;

